/// <amd-module name="typeahead/features/ContextualTAParamModifier" />

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [{
    lobs: ["HOTELS"],
}];

const featureFlag = "contextual_ta";

export class ContextualTAParamModifier implements IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }
}
